﻿let map;
let previousInfowindow = null;
let markers = [];
const centerOfBelgium = {
	lat: 50.503887,
	lng: 4.469936
}
const mapMarker = document.currentScript.dataset.mapMarker;
const tooltipAddress = document.currentScript.dataset.tooltipAddress;
const tooltipEmail = document.currentScript.dataset.tooltipEmail;
const tooltipPhoneNumber = document.currentScript.dataset.tooltipPhoneNumber;
const tooltipButtonColor = document.currentScript.dataset.tooltipButtonColor;
const tooltipButton = document.currentScript.dataset.tooltipButton;

function initMap() {
	map = new google.maps.Map(document.getElementById("map"), {
		zoom: 8,
		center: centerOfBelgium
	});

	document.querySelectorAll('*[data-umb-id]').forEach((element) => {
		const dataset = element.dataset;
		const coords = {
			lat: parseFloat(dataset.lat),
			lng: parseFloat(dataset.lng),
		};


		let contentString = `
        <div class="flex flex-col gap-4 text-left">
            <span class="font-semibold text-lg text-primary">${dataset.name}</span>

            <div class="flex flex-col">
                <span class="font-medium">${tooltipAddress}</span>
                <a class="flex flex-col w-fit underline" href="https://www.google.com/maps/dir/?api=1&destination=${dataset.street}%2C+${dataset.city}" target="_blank">
                	<span>${dataset.street}</span>
                	<span>${dataset.postalcode} ${dataset.city}</span>
				</a>
            </div>
			
			${dataset.email &&
			`<div class="flex flex-col">
				<span class="font-medium">${tooltipEmail}</span>
				<a class="underline" href="mailto:${dataset.email}">
					${dataset.email}
				</a>
			</div>`
			}

            <div class="flex flex-col">
                <span class="font-medium">${tooltipPhoneNumber}</span>
                <a class="underline" href="tel:${dataset.phonenumber}">
                	${dataset.phonenumber}
                </a>
            </div>

            <a 
            href="${dataset.url}"
            style="--markerTooltipButtonColor:  #${tooltipButtonColor}"
            class="office-tooltipButton">
                ${tooltipButton}
            </a>
        </div>
        `;

		const infowindow = new google.maps.InfoWindow({
			content: contentString
		});


		const marker = new google.maps.Marker({
			position: coords,
			map,
			icon: mapMarker,
		});

		listenMarker(marker, map, infowindow);
		markers.push(marker);
	});
}

function listenMarker(marker, map, infowindow) {
	google.maps.event.addListener(marker, 'click', function () {
		if (previousInfowindow) {

			previousInfowindow.close()
		}

		previousInfowindow = infowindow;

		infowindow.open(map, marker);
	});
}

window.initOfficeOverviewMap = initMap;

document.addEventListener('alpine:init', () => {
	Alpine.data('googleMaps', () => ({
		location: '',
		latitude: 0,
		longitude: 0,
		findMyLocationLoading: false,
		showLocationError: false,

		async init() {
			if (typeof window.google === 'undefined') {
				document.addEventListener('google:init', async () => {
					await this.initAutocomplete();
				})
			} else {
				await this.initAutocomplete();
			}
		},

		async initAutocomplete() {
			await agilitas.googleMaps.initialize((place) => {
				this.showLocationError = false;
				this.location = place.name;

				map.setZoom(12);
				map.panTo({ lat: place.lat, lng: place.lng })
				this.latitude = 0;
				this.longitude = 0;
			});
		},

		async findMyLocation() {
			this.showLocationError = false;

			try {
				this.findMyLocationLoading = true;
				const { name, latitude, longitude } = await agilitas.googleMaps.getLocation();

				this.location = name;

				map.setZoom(12);
				map.panTo({ lat: latitude, lng: longitude })
			} catch (error) {
				console.error('An error occured while retrieving current location', error);
			} finally {
				this.findMyLocationLoading = false;
				this.latitude = 0;
				this.longitude = 0;
			}
		},
		searchLocation() {
			this.showLocationError = false;

			if (this.latitude === 0 && this.longitude === 0) {
				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': this.location }, (results, status) => {
					if (status === "OK") {
						map.setZoom(12);
						map.panTo(results[0].geometry.location)
					} else {
						this.showLocationError = true
					}
				})
			}
		},
	}));
});